class TokenService {
    private static instance: TokenService;
  
    private constructor() {}
  
    public static getInstance(): TokenService {
      if (!TokenService.instance) {
        TokenService.instance = new TokenService();
      }
      return TokenService.instance;
    }
  
    public getToken = (): string | null => {
      return localStorage.getItem('token');
    };
  
    public parseToken = (isTokenInLocalStorage: boolean, token: string): any | null => {

      let tokenVal = '';
      if(!isTokenInLocalStorage){
        tokenVal = token;
      }else{
        tokenVal = this.getToken() ?? token;
      }
      
      if (tokenVal) {
        try {
          const base64Url = tokenVal.split('.')[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const jsonPayload = decodeURIComponent(
            atob(base64)
              .split('')
              .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
              })
              .join('')
          );
          return JSON.parse(jsonPayload);
        } catch (error) {
          console.error('Error decoding token:', error);
          return null;
        }
      }
      return null;
    };

    public isTokenAvailable = () => !!localStorage.getItem('token');

  }
  
  export default TokenService.getInstance();